import { UnauthenticatedTemplate } from '@azure/msal-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { SignButton } from '../components/SignButton';
import { useEffect, useState } from 'react';
import * as infotextsApi from '../api/Infotexts';


export const Login = () => {
  const intl = useIntl();
  const [header, setHeader] = useState("");
  const [text, setText] = useState("");
  const [data, setData] = useState([]);
  const [lang, setLang] = useState(intl.locale === "fi-FI" ? '_fi' : (intl.locale === "en-GB" ? '_en' : '_se'));
  
  useEffect(() => {
    infotextsApi.getWelcomeText().then((data: any) => {
      console.log("texts: ", data);
      if(data) {
        setData(data);
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLang(intl.locale === "fi-FI" ? '_fi' : (intl.locale === "en-GB" ? '_en' : '_se'));
  }, [intl.locale]);

  useEffect(() => {
    updateTexts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, data]);

  const updateTexts = async () => {
    let hText = data.find((t: { text_id: string; }) => t.text_id === 'login.info.header');
    let tText= data.find((t: { text_id: string; }) => t.text_id === 'login.info')
    if(hText) setHeader(hText['text'+lang]);
    if(tText) setText(tText['text'+lang]);
  }

  return (
    <>
      <UnauthenticatedTemplate>
        <div className="intro p-4 mb-5">
          { header && <h1>{header}</h1> }
          { text &&  <p>{text}</p> }
        </div>
        <div className="d-flex flex-md-row flex-column">
          <div className="p-4 login-box flex-fill">
            <h2 className="mb-4">
              <FormattedMessage id="login.loginbutton" />
            </h2>
            <SignButton/>
          </div>
          <div className="p-4 flex-fill add-box">
            <h2 className="mb-4"><FormattedMessage id={'login.missing.credentials.header'}/></h2>
            <p><FormattedMessage id={'login.missing.credentials'}/></p>
          </div>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
};